__webpack_require__.p = "/bizx-erp/speed-2026/";